"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRIGGERS = exports.TRANSLATION = exports.PLACEHOLDER_IMAGE = exports.DECIMAL_TYPE = exports.CONTENT_POSITION = exports.CANCELLATION_PENALTY_TYPES = void 0;
var CANCELLATION_PENALTY_TYPES = {
  FULL: 'Full',
  NONE: 'None',
  PARTIAL: 'Partial'
};
exports.CANCELLATION_PENALTY_TYPES = CANCELLATION_PENALTY_TYPES;
var DECIMAL_TYPE = {
  FLOAT: 'FLOAT',
  ROUND: 'ROUND',
  FLOOR: 'FLOOR',
  CEIL: 'CEIL'
};
exports.DECIMAL_TYPE = DECIMAL_TYPE;
var PLACEHOLDER_IMAGE = 'http://static.airasia.com/snap/images/hotel_image_holder.svg';
exports.PLACEHOLDER_IMAGE = PLACEHOLDER_IMAGE;
var CONTENT_POSITION = {
  RIGHT: 'RIGHT',
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  CUSTOM: 'CUSTOM'
};
exports.CONTENT_POSITION = CONTENT_POSITION;
var TRIGGERS = {
  hover: 'hover',
  click: 'click',
  focus: 'focus'
};
exports.TRIGGERS = TRIGGERS;
var TRANSLATION = {
  header: 'Hotel cancellation policy',
  bodyText: "Free cancellation only applies to hotel bookings and doesn't include flights."
};
exports.TRANSLATION = TRANSLATION;